import React from 'react';
import { useEquipmentType } from '../../../../../client/query/equipment-type';

import CategoryLink from '../../../../../components/category-link';

const QuickFindsRow: React.FC = () => {
  const { equipmentType } = useEquipmentType();
  return <CategoryLink equipmentType={equipmentType} />;
};

export default QuickFindsRow;
